// extracted by mini-css-extract-plugin
module.exports = {"form":"DividerForm_form__utb76","btn":"DividerForm_btn__Z9RIK","input":"DividerForm_input__4ocOA"};